import React, { FC } from 'react';
import { useInView } from 'react-intersection-observer';
import { CardWrapper } from 'components/Lane/Lane.css';
import { StandardCover } from 'types/Cover';
import { CardContainer, CardFrame, cardVariantCss } from './Card.css';
import { CardVariant, cardSpec } from './cardVariants';
import { coverDescription } from './cardCover';
import { CardBody } from './parts/CardBody';
import { CardInfo } from './parts/CardInfo';
import { CardLink } from './parts/CardLink';

export type CardStripePropTypes = {
    variant: CardVariant;
    asset: StandardCover;
    showDescription?: boolean;
    assetType?: string;
};

export const CardStripe: FC<CardStripePropTypes> = ({ variant, asset, showDescription, assetType, ...rest }) => {
    const spec = cardSpec(variant);
    const { title, metaData, isEntitled, defaultRenderSecondLine } = asset;

    const isEpisodeWithMetaData = assetType === 'episode' && !!metaData;
    const displayTitle = isEpisodeWithMetaData ? metaData : title;
    const displayDescription = spec.showInfo ? coverDescription(asset) : undefined;
    const linkLabel = [asset.channelName, title, isEpisodeWithMetaData ? metaData : null].filter(Boolean).join(', ');

    const [ref, inView] = useInView({
        threshold: 0,
    });

    return (
        <CardWrapper
            className={spec.wrapperClassName}
            variantCss={cardVariantCss(spec)}
            height={'auto'}
            width={'auto'}
            ref={ref}
            withDescription={showDescription && !!displayDescription}
        >
            {inView && (
                <CardContainer hasDescription={!!displayDescription} defaultRenderSecondLine={defaultRenderSecondLine}>
                    <CardLink cover={asset} style={{ display: 'inline-block' }} {...rest}>
                        <CardFrame data-test-id={spec.testId} defaultRenderSecondLine={defaultRenderSecondLine}>
                            <CardBody variant={variant} asset={asset} blurBackdrop srLabel={linkLabel} />
                        </CardFrame>
                    </CardLink>
                    {spec.showInfo && (
                        <CardInfo
                            hideTitleFromScreenReaders
                            title={displayTitle}
                            isLocked={isEntitled !== undefined && !isEntitled}
                            showDescription={!isEpisodeWithMetaData}
                            description={displayDescription}
                            metaData={metaData != null && assetType !== 'episode' ? metaData : undefined}
                        />
                    )}
                </CardContainer>
            )}
        </CardWrapper>
    );
};
